const WIFI_JOIN_ERROR_CODE_KEYS: Record<number, string> = {
    1: 'device_wifi_auth_frame_failed',
    2: 'device_wifi_authentication_failed',
    3: 'device_wifi_auth_algorithm_mismatch',
    4: 'device_wifi_association_failed',
    5: 'device_wifi_association_failed',
    6: 'device_wifi_rejected_by_access_point',
    7: 'device_wifi_disconnected_by_access_point',
    8: 'device_wifi_password_incorrect',
    9: 'device_wifi_password_incorrect',
    10: 'device_wifi_password_incorrect',
    11: 'device_wifi_association_timeout',
    12: 'device_wifi_network_not_found',
    13: 'device_wifi_channel_setup_failed',
    14: 'device_wifi_join_failed',
    15: 'device_wifi_add_station_failed',
    16: 'device_wifi_lost_access_point_signal',
    17: 'device_wifi_security_mismatch',
    18: 'device_wifi_password_length_invalid',
    21: 'device_wifi_power_save_handshake_failed',
    22: 'device_wifi_connection_lost',
    23: 'device_wifi_join_aborted',
    24: 'device_wifi_join_aborted',
    25: 'device_wifi_join_aborted',
    26: 'device_wifi_join_aborted'
};

const WIFI_JOIN_ERROR_MESSAGE_KEYS: Record<string, string> = {
    'auth frame allocate fail': 'device_wifi_auth_frame_failed',
    'authentication fail': 'device_wifi_authentication_failed',
    'auth algorithm mismatch': 'device_wifi_auth_algorithm_mismatch',
    'assoc frame allocate fail': 'device_wifi_association_failed',
    'association fail': 'device_wifi_association_failed',
    'rejected by access point': 'device_wifi_rejected_by_access_point',
    'disconnected by access point': 'device_wifi_disconnected_by_access_point',
    'password incorrect': 'device_wifi_password_incorrect',
    'access point assoc timeout': 'device_wifi_association_timeout',
    'network not found': 'device_wifi_network_not_found',
    'channel setup failed': 'device_wifi_channel_setup_failed',
    'failed to join network': 'device_wifi_join_failed',
    'add station failure': 'device_wifi_add_station_failed',
    'lost access point signal': 'device_wifi_lost_access_point_signal',
    'security type mismatch': 'device_wifi_security_mismatch',
    'password length invalid': 'device_wifi_password_length_invalid',
    'power save handshake failed': 'device_wifi_power_save_handshake_failed',
    'connection lost': 'device_wifi_connection_lost',
    'bad_ssid': 'device_wifi_invalid_ssid',
    'bad_psk': 'device_wifi_password_length_invalid',
    'no_ssid': 'device_wifi_invalid_ssid',
    'busy': 'device_wifi_device_busy',
    'not_provisioning': 'device_wifi_not_provisioning'
};

export const provisioningErrorTranslationKeys = new Set([
    'device_wifi_connection_failed',
    'device_wifi_response_lost',
    'device_wifi_auth_frame_failed',
    'device_wifi_authentication_failed',
    'device_wifi_auth_algorithm_mismatch',
    'device_wifi_association_failed',
    'device_wifi_rejected_by_access_point',
    'device_wifi_disconnected_by_access_point',
    'device_wifi_password_incorrect',
    'device_wifi_association_timeout',
    'device_wifi_network_not_found',
    'device_wifi_channel_setup_failed',
    'device_wifi_join_failed',
    'device_wifi_add_station_failed',
    'device_wifi_lost_access_point_signal',
    'device_wifi_security_mismatch',
    'device_wifi_password_length_invalid',
    'device_wifi_power_save_handshake_failed',
    'device_wifi_connection_lost',
    'device_wifi_join_aborted',
    'device_wifi_invalid_ssid',
    'device_wifi_device_busy',
    'device_wifi_not_provisioning',
    'ble_not_available',
    'ble_not_enabled',
    'ble_permission_denied',
    'ble_connection_failed',
    'ble_connection_timeout',
    'ble_services_timeout',
    'ble_notification_timeout',
    'ble_write_timeout',
    'ble_provisioning_access_timeout',
    'ble_provisioning_access_unavailable',
    'device_not_in_setup_mode',
    'device_setup_unreachable',
    'ble_wifi_scan_timeout',
    'ble_scan_record_malformed',
    'ble_wifi_join_timeout'
]);

export function normalizeProvisioningErrorMessage(message: string): string {
    if (message.startsWith('error:')) {
        return wifiJoinErrorKeyFromDeviceStatus(message.substring('error:'.length));
    }

    return message;
}

export function wifiJoinErrorFromDeviceStatus(status: string): Error {
    return new Error(wifiJoinErrorKeyFromDeviceStatus(status));
}

export function wifiJoinErrorFromHttpResponse(data: unknown): Error {
    const body = parseResponseBody(data);
    const key = wifiJoinErrorKeyFromCode(body?.code) ?? wifiJoinErrorKeyFromReason(body?.message);
    return new Error(key ?? 'device_wifi_connection_failed');
}

export function wifiJoinErrorFromHttpFailure(error: any): Error | undefined {
    const data = error?.data ?? error?.response?.data ?? error?.body ?? error?.response;
    if (data === undefined) {
        return undefined;
    }

    return wifiJoinErrorFromHttpResponse(data);
}

function wifiJoinErrorKeyFromDeviceStatus(status: string): string {
    return wifiJoinErrorKeyFromCode(status) ?? wifiJoinErrorKeyFromReason(status) ?? 'device_wifi_connection_failed';
}

function wifiJoinErrorKeyFromCode(code: unknown): string | undefined {
    const numericCode = typeof code === 'number' ? code : Number.parseInt(String(code), 10);
    return Number.isFinite(numericCode) ? WIFI_JOIN_ERROR_CODE_KEYS[numericCode] : undefined;
}

function wifiJoinErrorKeyFromReason(reason: unknown): string | undefined {
    if (typeof reason !== 'string') {
        return undefined;
    }

    return WIFI_JOIN_ERROR_MESSAGE_KEYS[reason.trim().toLowerCase()];
}

function parseResponseBody(data: unknown): { code?: unknown; message?: unknown } | undefined {
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        }
        catch {
            return { message: data };
        }
    }

    if (data && typeof data === 'object') {
        return data as { code?: unknown; message?: unknown };
    }

    return undefined;
}
